export default {
	"transportOrderInfoOfTransportPlan": {
		"changeTime": "การปรับเปลี่ยนเวลา"
	},
	"transportPlan": {
		"askCompleteTime": "ระบุเวลาที่ต้องดำเนินการให้เสร็จสมบูรณ์"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/transportPlan/transportPlan.js